import { styled } from "styled-components";
const ContentTitle = styled("h3")(
  ({ theme }) => ({
    color: "rgba(0, 0, 0, 0.45)",
    fontFamily: theme.fontFamily.default,
    margin: "0 0 1em",
    textTransform: "uppercase"
  }),
  ({ magnitude, theme }) => ({
    fontSize: theme.fontSize[magnitude],
    lineHeight: theme.lineHeight[magnitude]
  })
);
export {
  ContentTitle
};
